/**
 * Created by v-grfore on 22/01/2017.
 */
import * as React from "react";
import { SVGHelpers } from "../SvgHelpers";
import { Helpers } from "../Helpers";
import { CssClassAndIdNames, Names, ClassAndIdNames } from "../CssClassAndIdNames";
import { AddWbsComponentEvents, SelectNodeEvents, EditNodeEvents } from "../WbsEvents";
import { PropsAuthorizations } from './Wbs';
import { AddWbsComponentMenu, PropsAddWbsComponentMenu } from "./AddWbsComponentMenu";
import { BBoxRectangle } from '../layout/WbsLayout';

// import EventHandler = React.EventHandler;
// import MouseEventHandler = React.MouseEventHandler;
import MouseEvent = React.MouseEvent;

export interface NodeDataDefinition {
  data: {
    id: string;
    wbsId: string;
    parent?: string;
    work?: number;
    cost?: number;
    layoutStyle: number;
    title: string;
    visibility: string;
  };
}

export interface NodesData extends Array<NodeDataDefinition> {}

export interface PropsWbsElement {
  wbsComponentId: string;
  wbsComponentTitle: string;
}

export interface TextDimensions {
  title: BBoxRectangle;
  id: BBoxRectangle;
  label: BBoxRectangle;
}

export interface WbsComponentBox {
  nodeId: string;
  x: number;
  y: number;
  width: number;
  height: number;
}

//export interface PropsWbsComponent extends PropsWbsElement, WbsComponentBox, AddWbsComponentEvents, SelectNodeEvents, TextDimensions {
export interface PropsWbsComponent extends PropsWbsElement, WbsComponentBox, AddWbsComponentEvents, SelectNodeEvents, EditNodeEvents, PropsAuthorizations {
  textDimensions: TextDimensions;  
  wbsComponentWork?: number;
  wbsComponentCost?: number;
  issueCount?: number;
  riskCount?: number;
  todoCount?: number;
  communicationCount?: number;
}

export interface WbsComponentData extends WbsComponentBox {
  layoutStyle: number;
}

export const X_TEXT_TO_BOX_OFFSET: number = 5;



//export const WbsComponent: React.SFC<PropsWbsComponent> = props => {
export class WbsComponent extends React.Component<PropsWbsComponent>{

  public static X_TEXT_TO_BOX_OFFSET: number = 5;  
  private canRename: boolean = false;
  private canAddChild: boolean = false;

  constructor(props: PropsWbsComponent) {
      super(props); //this creates the react component
      // now we extend it if needed
      this.canRename = props.canRename;
      this.canAddChild = props.canAddChild;
      this.handleKeyPress = this.handleKeyPress.bind(this);                
  }
  
  private handleKeyPress(e: any) {
    console.log('enter press here! ')
		if(e.key == 'Enter'){
      console.log('enter press here! ')
    }
	}

  public render() {

    // get classes and id names for the html Components
    const classAndIdWbsComponent:       ClassAndIdNames = CssClassAndIdNames.getClassAndIdNames(Names.WbsComponent,           this.props.nodeId);
    const classAndIdWbsComponentBox:    ClassAndIdNames = CssClassAndIdNames.getClassAndIdNames(Names.WbsComponent_Box,       this.props.nodeId);
    const classAndIdWbsComponentId:     ClassAndIdNames = CssClassAndIdNames.getClassAndIdNames(Names.WbsComponent_WbsId,     this.props.nodeId);
    const classAndIdWbsComponentTitle:  ClassAndIdNames = CssClassAndIdNames.getClassAndIdNames(Names.WbsComponent_Title,     this.props.nodeId);
    const classAndIdWbsComponentLabel:  ClassAndIdNames = CssClassAndIdNames.getClassAndIdNames(Names.WbsComponent_DataLabel, this.props.nodeId);
    const classAndIdWbsComponentMenu:   ClassAndIdNames = CssClassAndIdNames.getClassAndIdNames(Names.AddWbsComponentMenu,    this.props.nodeId);


    // Box corners
    const rx: number = 4;
    const ry: number = 4;

    const cost: string = Helpers.formatCurrency(this.props.wbsComponentCost, "€");
    const work: string = Helpers.formatWork(this.props.wbsComponentWork, "d");

    //Calculate dimensions
    const titleDimensions: BBoxRectangle = {
      width: SVGHelpers.getTextWidth( this.props.wbsComponentTitle, this.props.textDimensions.title.width ),
      height: this.props.textDimensions.title.height
    };
    const costLabelDimensions: BBoxRectangle = {
      width: SVGHelpers.getTextWidth( cost, this.props.textDimensions.label.width ),
      height: this.props.textDimensions.label.height
    };
    const workLabelDimensions: BBoxRectangle = {
      width: SVGHelpers.getTextWidth( work, this.props.textDimensions.label.width ),
      height: this.props.textDimensions.label.height
    };
    const wbsIdDimensions: BBoxRectangle = {
      width: SVGHelpers.getTextWidth( this.props.wbsComponentId, this.props.textDimensions.id.width ),
      height: this.props.textDimensions.id.height
    };

    const spaceWidth: number = SVGHelpers.getTextWidth( "_", this.props.textDimensions.title.width ) ;
    const dataLabelHeight: number = costLabelDimensions.height;

    const xId: number =
      this.props.x +
      X_TEXT_TO_BOX_OFFSET;

    // title
    const xMidTitle: number =
      xId + wbsIdDimensions.width +
      spaceWidth +
      titleDimensions.width / 2;

    const xMidBox: number = this.props.x + this.props.width / 2;

    let xTitle: number;
    if (xMidTitle < xMidBox) {
      xTitle = xMidBox - titleDimensions.width / 2;
    } else {
      xTitle = xId + wbsIdDimensions.width + spaceWidth;
    }

    const yTitle: number = this.props.y + titleDimensions.height + 4;

    const xDataLabel: number = xId + 5;
    const xDataValueCost: number = xId + 110 - costLabelDimensions.width;
    const xDataValueWork: number = xId + 110 - workLabelDimensions.width;
    const yDataLabelWork: number = yTitle + dataLabelHeight + 6;
    const yDataLabelCost: number = yDataLabelWork + dataLabelHeight + 6;

    // id
    const yId: number = yTitle;

    const propsAddWbsComponentMenu: PropsAddWbsComponentMenu = {
      className: classAndIdWbsComponentMenu.className,
      x: xId + 10,
      y: yDataLabelCost + 23,
      nodeId: this.props.nodeId,
      onAddChild: this.props.onAddChild,
      onInsertParent: this.props.onInsertParent,
      onAddSiblingBefore: this.props.onAddSiblingBefore,
      onAddSiblingAfter: this.props.onAddSiblingAfter
    };

    let onWbsComponentRightClick = (e: MouseEvent<any>) => {
      e.preventDefault();
      this.props.onComponentOpenMenu(this.props.nodeId)
    };


    const propsWbsComponent = {
      key: classAndIdWbsComponentId.idName,
      className: classAndIdWbsComponent.className,
      id: classAndIdWbsComponentId.idName
    };

    const propsWbsComponentBox = {
      key: classAndIdWbsComponentBox.idName,
      className: classAndIdWbsComponentBox.className,
      id: classAndIdWbsComponentBox.idName,
      x: this.props.x,
      y: this.props.y,
      width: this.props.width,
      height: this.props.height,
      rx: rx,
      ry: ry,
      onClick: (e: MouseEvent<any>) => this.props.onComponentSelected(this.props.nodeId),
      onContextMenu: (e: MouseEvent<any>) => onWbsComponentRightClick(e)
    };

    const propsWbsId = {
      key: classAndIdWbsComponentId.idName,
      className: classAndIdWbsComponentId.className,
      id: this.props.wbsComponentId,
      x: xId,
      y: yId
    };

    const propsWbsComponentTitle = {
      key: classAndIdWbsComponentTitle.idName,
      className: classAndIdWbsComponentTitle.className,
      id: classAndIdWbsComponentTitle.idName,
      x: xTitle,
      y: yTitle,
      // onClick: (e: MouseEvent<any>) => this.props.onTitleEditRequest(this.props.nodeId, this.props.wbsComponentTitle)
      onClick: (e: MouseEvent<any>) => ( this.canRename ) ? this.props.onTitleEditRequest(this.props.nodeId, this.props.wbsComponentTitle) : null
      //( this.editMode ) ? <AddWbsComponentMenu {...propsAddWbsComponentMenu} /> : null;
    };

    const propsWorkLabel = {
      className: classAndIdWbsComponentLabel.className,
      x: xDataLabel,
      y: yDataLabelWork
    };

    const propsWorkValue = {
      className: classAndIdWbsComponentLabel.className,
      x: xDataValueWork,
      y: yDataLabelWork
    };

    const propsCostLabel = {
      className: classAndIdWbsComponentLabel.className,
      x: xDataLabel,
      y: yDataLabelCost
    };

    const propsCostValue = {
      className: classAndIdWbsComponentLabel.className,
      x: xDataValueCost,
      y: yDataLabelCost
    };

    const addWbsComponentMenu: JSX.Element = ( this.canAddChild ) ? <AddWbsComponentMenu {...propsAddWbsComponentMenu} /> : null;

    return (
      
      <g {...propsWbsComponent} >
        <rect tabIndex={0} {...propsWbsComponentBox} />

        <text {...propsWbsId} >
          {this.props.wbsComponentId}
        </text>

        <text {...propsWbsComponentTitle} >
          {this.props.wbsComponentTitle}
        </text>

        <text {...propsWorkLabel} >
          Work:
        </text>
        <text {...propsWorkValue} >
          {work}
        </text>

        <text {...propsCostLabel} >
          Cost:
        </text>
        <text {...propsCostValue} >
          {cost}
        </text>
        {addWbsComponentMenu}
      </g>
      
    );
  }
};//<foreignObject x={xTitle-10} y={yTitle-17} className={classAndIdWbsComponentTitle.className} width="400"  ><div {...propsWbsComponentTitle}>Hello From SVG</div></foreignObject>
/*
<EditableSvgLabel x={xTitle} y={yTitle} onChange={this.handleChangeTitle} {...propsWbsComponentTitle} >
          {this.state.title}
        </EditableSvgLabel>
*/


// WEBPACK FOOTER //
// ./src/components/WbsComponent.tsx